import React, { useEffect, useMemo, useState } from "react";
import { useCaseManagement } from "./store";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getValue, isDownloadDisabled } from "modules/utilities/utility";
import PaginationDiv from "modules/pagination/PaginationDiv";
import SlotTableData from "./SlotTableData";
import { Button } from "antd";
import CardDiv from "modules/common/card-div/CardDiv";
import SlotBookingCanvas from "./SlotBookingCanvas";
import { useToast } from "modules/navbar/top/store/toasterStore";
import moment from "moment";

function CaseSlotBooking() {
  const {
    salesReps,
    slotData,
    slotLoading,
    fetchSalesRep,
    fetchSlotBooking,
    postRequestReport,
  } = useCaseManagement();
  const location = useLocation();
  const navigate = useNavigate();
  const [page, newPage] = useState(1);
  const { setToaster } = useToast();
  const searchParams = new URLSearchParams(location.search);
  const pageData = searchParams.get("pageNumber") || null;
  const isFinished = searchParams.get("isFinished") || null;
  const assignedTo = searchParams.get("assignedTo") || null;
  const slotStartDate = searchParams.get("slotStartDate") || null;
  const slotEndDate = searchParams.get("slotEndDate") || null;
  const bookingStartDate = searchParams.get("bookingStartDate") || null;
  const bookingEndDate = searchParams.get("bookingEndDate") || null;
  const repLevel = searchParams.get("repLevel") || null;
  const category = searchParams.get("category") || null;
  const [queryParams, setQueryParams] = useState("");

  useEffect(() => {
    fetchSalesRep();
  }, []);

  useEffect(() => {
    const queryParamsArray = [
      bookingStartDate && `bookingStartDate=${bookingStartDate}`,
      bookingEndDate && `bookingEndDate=${bookingEndDate}`,
      slotStartDate && `slotStartDate=${encodeURIComponent(slotStartDate)}`,
      slotEndDate && `slotEndDate=${encodeURIComponent(slotEndDate)}`,
      assignedTo && `assignedTo=${assignedTo}`,
      isFinished && `isFinished=${isFinished}`,
      repLevel && `repLevel=${repLevel}`,
      category && `category=${category}`,
    ].filter(Boolean);
    const queryParams = queryParamsArray.join("&");
    setQueryParams(queryParams);
  }, [
    isFinished,
    assignedTo,
    slotStartDate,
    slotEndDate,
    bookingStartDate,
    bookingEndDate,
    repLevel,
    category,
  ]);

  useEffect(() => {
    if (queryParams) {
      navigate(
        `/case-management/slotBooking?${queryParams}&pageNumber=${page}`
      );
    } else {
      navigate(`/case-management/slotBooking?pageNumber=${page}`);
    }
  }, [page, queryParams]);

  useEffect(() => {
    const queryParamsArray = [
      bookingStartDate && `bookingStartDate=${ moment.utc(bookingStartDate).valueOf() }`,
      bookingEndDate && `bookingEndDate=${moment.utc(bookingEndDate).valueOf()}`,
      slotStartDate && `slotStartDate=${(moment(slotStartDate)).toISOString()}`,
      slotEndDate && `slotEndDate=${(moment(slotEndDate)).toISOString()}`,
      assignedTo && `assignedTo=${assignedTo}`,
      isFinished && `isFinished=${isFinished}`,
      repLevel && `repLevel=${repLevel}`,
      category && `category=${category}`,
    ].filter(Boolean);
    const queryParams = queryParamsArray.join("&");
    if (pageData) {
      fetchSlotBooking(`${queryParams}&pageNumber=${pageData}`);
    }
  }, [pageData, queryParams]);

  useEffect(() => {
    newPage(Number(pageData));
  }, [pageData]);

  const handleDownload = () => {
    postRequestReport(
      {
        report: "SLOT_BOOKINGS",
        meta: {
          pageNumber: pageData || "1",
          isRescheduled: "false",
          isUserBooked: "true",
        },
      },
      setToaster
    );
  };

  const tableData = useMemo(() => {
    if (!slotData) return { data: [], rowCount: 0, pageCount: 0 };
    const _data = slotData.data?.map((item) => ({
      key: getValue(item, "id"),
      bookingTime: getValue(item, "updated_at"),
      caseId: getValue(item, "case.id"),
      email: getValue(item, "case.user.email"),
      isFinished: getValue(item, "is_finished"),
      name: getValue(item, "case.user.first_name"),
      phoneNo: getValue(item, "case.user.phone_number"),
      rep: getValue(item, "user.first_name"),
      repLevel: getValue(item, "user.level"),
      slotTime: getValue(item, "slot.slot_time"),
      status: getValue(item, "case.status"),
      formStatus: getValue(item, "case.form_status"),
      feedback: getValue(item, "case.feedback"),
      isUserBooked: getValue(item, "is_user_booked"),
      isResheduled: getValue(item, "is_rescheduled"),
    }));

    return {
      data: _data,
      rowCount: slotData.pagination?.rowCount,
      pageCount: slotData.pagination?.pageCount,
    };
  }, [slotData]);

  const showSalesReps = useMemo(() => {
    if (!salesReps) return [];
    return salesReps?.userRole?.filter((rep) => rep.user.level === 1);
  }, [salesReps]);

  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-end">
          <div className="d-flex gap-5 align-items-center">
            <Button className="btb btn-primary text-primary" onClick={handleDownload} disabled={isDownloadDisabled}>
              Download
            </Button>
            <SlotBookingCanvas salesReps={salesReps} />
          </div>
        </div>
      }
      component={
        <div>
          <SlotTableData tableData={tableData} isLoading={slotLoading} />
          <PaginationDiv
            paginationData={{
              pageCount: slotData.pagination?.pageCount
                ? slotData.pagination?.pageCount
                : 1,
              page: page,
            }}
            newPage={newPage}
          />
        </div>
      }
    />
  );
}

export default CaseSlotBooking;
